import React from "react";
import styles from "./modal-table.module.scss";
import ArrowIcon from "../../../../icons/arrow.icon";

// Column definitions with their width classes
const columnDefinitions = {
  companyName: { label: "Company name", widthClass: styles.width240, hasArrow: true },
  location: { label: "Location", widthClass: styles.width160, hasArrow: false },
  salesRep: { label: "Sales Rep", widthClass: styles.width234, hasArrow: false },
  startDate: { label: "Start Date", widthClass: styles.width160, hasArrow: false },
  endDate: { label: "End Date", widthClass: styles.width160, hasArrow: false },
  trialDays: { label: "Trial Days", widthClass: styles.width146, hasArrow: false },
  currentSubscription: { label: "Current Subscription", widthClass: styles.width140, hasArrow: false },
  integrations: { label: "Integrations", widthClass: styles.width213, hasArrow: false },
  products: { label: "Products", widthClass: styles.width96, hasArrow: false },
  services: { label: "Services", widthClass: styles.width96, hasArrow: false },
  packages: { label: "Packages", widthClass: styles.width88, hasArrow: false },
  conversionDate: { label: "Conversion Date", widthClass: styles.width160, hasArrow: false },
};

// Column configurations for each metric type
const getColumnsForMetric = (metricLabel) => {
  if (!metricLabel) {
    // Default: New Trials columns
    return [
      "companyName",
      "location",
      "salesRep",
      "startDate",
      "endDate",
      "trialDays",
      "currentSubscription",
      "integrations",
      "products",
      "services",
      "packages",
    ];
  }

  const label = metricLabel.toLowerCase();

  if (label.includes("new trial")) {
    return [
      "companyName",
      "location",
      "salesRep",
      "startDate",
      "endDate",
      "trialDays",
      "currentSubscription",
      "integrations",
      "products",
      "services",
      "packages",
    ];
  }

  if (label.includes("extended trial")) {
    return [
      "companyName",
      "location",
      "salesRep",
      "startDate",
      "endDate",
      "currentSubscription",
      "trialDays",
    ];
  }

  if (label.includes("expired trial")) {
    return [
      "companyName",
      "location",
      "salesRep",
      "startDate",
      "endDate",
      "currentSubscription",
      "trialDays",
    ];
  }

  if (label.includes("converted")) {
    return [
      "companyName",
      "location",
      "salesRep",
      "startDate",
      "endDate",
      "currentSubscription",
      "trialDays",
      "conversionDate",
    ];
  }

  if (label.includes("avg") || label.includes("trial length")) {
    return [
      "companyName",
      "startDate",
      "endDate",
      "currentSubscription",
      "trialDays",
      "conversionDate",
    ];
  }

  // Default fallback
  return [
    "companyName",
    "location",
    "salesRep",
    "startDate",
    "endDate",
    "trialDays",
    "currentSubscription",
  ];
};

export const TableHeader = ({ metric = null }) => {
  const metricLabel = metric?.label || "";
  const columnKeys = getColumnsForMetric(metricLabel);
  const navigationColumns = columnKeys.map((key) => columnDefinitions[key]).filter(Boolean);

  return (
    <header className={styles.modalTableHeader}>
      {navigationColumns.map((column, index) => {
        const isFirstColumn = index === 0;
        return (
          <div
            key={`${column.label}-${index}`}
            className={`${styles.modalTableHeaderColumn} ${column.widthClass}`}
          >
            {isFirstColumn ? (
              <div className={styles.modalTableHeaderColumnWrapper}>
                <div className={styles.modalTableHeaderCell}>
                  <div className={styles.modalTableHeaderCellInner}>
                    <div className={styles.modalTableHeaderLabel}>
                      {column.label}
                    </div>
                  </div>

                  {column.hasArrow && (
                    <div className={styles.modalTableArrowContainer}>
                      <ArrowIcon className={styles.modalTableArrowIcon} width="10px" height="10px" fill="#616778" style={{ transform: 'rotate(-90deg)', width: '10px', height: '10px' }}/>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className={styles.modalTableHeaderCell}>
                <div className={styles.modalTableHeaderCellInner}>
                  <div className={styles.modalTableHeaderLabel}>
                    {column.label}
                  </div>
                </div>

                {column.hasArrow && (
                  <div className={styles.modalTableArrowContainer}>
                    <ArrowIcon className={styles.modalTableArrowIcon} width="10px" height="10px" fill="#616778" style={{ transform: 'rotate(-90deg)', width: '10px', height: '10px' }}/>
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </header>
  );
};
